export default __webpack_public_path__ + "static/media/loginImg.178c0e81.jpg";